import React from 'react';

export type ExternalLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const ExternalLink = (props: ExternalLinkProps) => {
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a target="_blank" rel="noreferrer" {...props} />;
};
